<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Reporting</h1>
    <p>Qtac provide a standard library of reports to each client - <a href="#" @click.prevent="showHelpPanel = !showHelpPanel">view reports</a>.</p>

    <div class="help-panel" style="margin-bottom: 20px;" v-if="showHelpPanel" >
      <div style="float: right;"><button type="button" style="font-size: 40px; margin-top:-20px;" @click.prevent="showHelpPanel = !showHelpPanel">&times;</button></div>
      <h4>Default Reports</h4>
      <p>
        <ul>
          <li v-for="(report, idx) in defaultReports" :key="idx">
            {{ report }}
          </li>
        </ul>
      </p>
    </div>


    <p>Would you like to discuss any requirements beyond Qtac's standard reporting package?</p>





    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
            <label class="radio-label custom-check"><input type="radio" value=true v-model="formData.requiresAdditionalReports">Yes<span class="radiomark"></span></label>
            <label class="radio-label custom-check"><input type="radio" value=false v-model="formData.requiresAdditionalReports">No<span class="radiomark"></span></label>
      </form>
    </div>

  </div>


</template>


<script setup>

import { ref, watch } from 'vue'

const error = ref(null)
const showHelpPanel = ref(false);
import defaultReports from '@/helpers/arrays/defaultReports';

const props = defineProps({
  formData: Object
})


const validateStep = () => {
  if (props.formData.requiresAdditionalReports === undefined || props.formData.requiresAdditionalReports === null || props.formData.requiresAdditionalReports === '') {
    error.value = 'Please select an option.';
    return false;
  }
  error.value = null;
  return true;
}


const executeStep = async () => {
  return true;
}



defineExpose({ validateStep, executeStep });

</script>